import i18n, { type AvaliableLocales } from '@/i18n';
import { useApi } from '@/api';

import en from '@/i18n/locales/en';
import ru from '@/i18n/locales/ru';

import {
  I18N_SET_LANG,
  I18N_LOAD_LANG,
} from '../action_types/i18n';
import type { ActionContext } from 'vuex';
import type { RootState } from '..';
import type { TypedStoreModule } from '@/types/vuex';

export interface I18nState {
  lang: AvaliableLocales,
  loadedLangs: string[],
}

// interface Messages {
//   lang: AvaliableLocales,
//   locale: any,
// }

const messagesDictionary = {
  en,
  ru,
};

const getters = {
  currentLang: (state: I18nState) => state.lang,
};

const actions = {
  [I18N_SET_LANG]: ({ commit }: ActionContext<I18nState, RootState>, payload: AvaliableLocales) => new Promise((resolve, reject) => {
    if (payload !== state.lang) {
      if (state.loadedLangs.includes(payload)) {
        commit(I18N_SET_LANG, payload);
        resolve(payload);
      } else {
        const messages = messagesDictionary[payload];
        commit(I18N_LOAD_LANG, {
          lang: payload,
          locale: messages,
        });
        commit(I18N_SET_LANG, payload);
        resolve(payload);
      }
    }
    resolve(payload);
  }),
};

const mutations = {
  [I18N_SET_LANG]: (state: I18nState, payload: AvaliableLocales) => {
    const api = useApi();
    
    state.lang = payload;
    i18n.global.locale.value = payload;
    api.affiliatesApi.defaults.headers.common['X-Selected-Locale'] = payload;
    api.miscApi.defaults.headers.common['X-Selected-Locale'] = payload;
    document.querySelector('html')!.setAttribute('lang', payload);
    localStorage.setItem('language', payload);
  },
  // [I18N_LOAD_LANG]: (state: I18nState, payload: Messages) => {
  //   state.loadedLangs.push(payload.lang);
  //   i18n.setLocaleMessage(payload.lang, payload.locale.default);
  // },
};

const state: I18nState = {
  //@ts-expect-error инициализация без проверки типа
  lang: '',
  loadedLangs: ['en', 'ru'],
};

const storeModule = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}

export type I18nModule = TypedStoreModule<'i18n', typeof storeModule>;

export default storeModule;
